import { useEffect, useState } from "react";
import { Languages } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function LanguageSettings() {
  const { user, refresh } = useAuth();
  const [langs, setLangs] = useState([]);
  useEffect(() => { api.get("/languages").then((r) => setLangs(r.data)); }, []);

  const change = async (v) => {
    try {
      await api.post("/profile/language", { native_language: v === "none" ? null : v });
      await refresh();
      toast.success(v === "none" ? "Traductions désactivées" : "Langue enregistrée");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div className="bg-white rounded-2xl border-2 border-slate-200 p-4 space-y-3 rise rise-1" data-testid="language-settings">
      <div className="flex items-center gap-3">
        <span className="w-12 h-12 rounded-xl bg-sky-600 text-white grid place-items-center">
          <Languages className="w-6 h-6" />
        </span>
        <div className="flex-1">
          <div className="font-display text-xl font-bold uppercase">Ma langue</div>
          <div className="text-sm text-slate-600">Traduction des mots dans votre langue</div>
        </div>
      </div>
      <Select value={user.native_language || "none"} onValueChange={change}>
        <SelectTrigger className="h-12 text-base" data-testid="language-select">
          <SelectValue placeholder="Choisir" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none" data-testid="language-option-none">Pas de traduction</SelectItem>
          {langs.map((l) => (
            <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>
              {l.label.charAt(0).toUpperCase() + l.label.slice(1)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
